export function numericColorToHex(numericColor: number): string {
  const bbggrr = ('000000' + numericColor.toString(16)).slice(-6);
  const rrggbb = bbggrr.substr(4, 2) + bbggrr.substr(2, 2) + bbggrr.substr(0, 2);
  return '#' + rrggbb;
}

export const delay = (time: number) => new Promise(res => setTimeout(res, time));

export function isOlderThanOneDay(then: Date): boolean {
  const now = new Date();
  const msBetweenDates = Math.abs(then.getTime() - now.getTime());

  // 👇️ convert ms to days                 hour   min  sec   ms
  const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000);
  return daysBetweenDates > 1;
}

export function compareVersionNumbers(v1: string, v2: string): number {
  if (!v1 || !v2) {
    return -1;
  }

  const v1parts = v1.split('.');
  const v2parts = v2.split('.');

  // First, validate both numbers are true version numbers
  if (!_validateParts(v1parts) || !_validateParts(v2parts)) {
    return -1;
  }

  const len = Math.max(v1parts.length, v2parts.length);

  // Normalize lengths with 0 components
  // This ensures 10.0.1 > 10
  if (v1parts.length < v2parts.length) {
    for (let i = 0; i < len; i++) {
      v1parts.push('0');
    }
  } else if (v2parts.length < v1parts.length) {
    for (let i = 0; i < len; i++) {
      v2parts.push('0');
    }
  }

  // loop while the components are equal
  for (let i = 0; i < len; i++) {
    // A bigger than B
    if (parseInt(v1parts[i], 10) > parseInt(v2parts[i], 10)) {
      return 1;
    }

    // B bigger than A
    if (parseInt(v1parts[i], 10) < parseInt(v2parts[i], 10)) {
      return -1;
    }
  }

  // Otherwise they are the same.
  return 0;
}

function _validateParts(parts): boolean {
  for (const part of parts) {
    if (!/^\d+$/.test(part)) {
      return false;
    }
  }
  return true;
}
